import { ConfigProvider, theme, Dropdown as AntDropdown } from 'antd';

import { memo } from 'react';

const Dropdown = ({
  children,
  ...rest
}): JSX.Element => {

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          fontSize: 12,
          borderRadiusSM: 2,
          borderRadiusLG: 2,
          borderRadius: 2,
          colorPrimary: '#39C2D7',
          colorPrimaryHover: '#2799b0',
          colorText: '#fff',
          colorBgBase: '#172126',
          colorBgContainer: 'transparent',
          colorBorder: '#647a87',
          controlItemBgActiveDisabled: '#2C4654',
          controlItemBgActive: '#2C4654',
          controlOutlineWidth: 0,
          colorBgElevated: '#1F313B',
        },
        components: {
          Menu: {
            colorItemBg: 'transparent',
            colorItemBgSelected: '#2c5166',
          },
        },
      }}
    >
      <AntDropdown {...rest}>{children}</AntDropdown>
    </ConfigProvider>
  );
};

export default memo(Dropdown);
